import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./trinity-player.m.css";

const TrinityPlayer = ({ storyUrl }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !containerRef.current) return;

    // Essential configuration for multiple/dynamic players
    window.__trinityMultiplePlayers__ = true;
    containerRef.current.innerHTML = "";

    // 1. Create the loading DIV
    const loadingDiv = document.createElement("div");
    loadingDiv.className = "trinity-tts-pb";
    loadingDiv.setAttribute("dir", "ltr");
    loadingDiv.style.cssText = "font: 12px / 18px Verdana, Arial; height: 80px; line-height: 80px; text-align: left; margin: 0 0 0 82px;";
    loadingDiv.innerHTML = '<strong style="font-weight: 400">Getting your <a href="//trinityaudio.ai" style="color: #4b4a4a; text-decoration: none; font-weight: 700;">Trinity Audio</a> player ready...</strong>';
    containerRef.current.appendChild(loadingDiv);



    // Configuration selectors
    const contentSelector = ".headline, .subheadline, .trinity-read";
    const waitSelector = ".trinity-read";

    const pageURL = storyUrl || window.location.href;

    // 2. Create the script element
    const scriptEl = document.createElement("script");
    scriptEl.setAttribute("fetchpriority", "high");
    scriptEl.setAttribute("charset", "UTF-8");
    scriptEl.setAttribute("data-player-id", "trinity-audio-player");
    scriptEl.setAttribute("data-unit-id", "2900024070");
    scriptEl.setAttribute("data-unit-type", "tts-player");

    const scriptURL = new URL("https://trinitymedia.ai/player/trinity/2900024070/");
    scriptURL.searchParams.set("pageURL", pageURL);
    
    // Pass parameters in URL as required by Trinity docs
    scriptURL.searchParams.set("textSelector", btoa(contentSelector));
    scriptURL.searchParams.set("documentLoadType", "onSelectorVisible");
    scriptURL.searchParams.set("documentLoadTypeSelector", btoa(waitSelector));
    
    scriptEl.src = scriptURL.toString();

    // 3. Append script to container
    containerRef.current.appendChild(scriptEl);
  }, [storyUrl]);

  return (
    <div
      styleName="trinity-player-container"
      className="trinity-tts-placeholder-icon-player"
      data-player-id="trinity-audio-player"
      ref={containerRef}
    />
  );
};

TrinityPlayer.propTypes = {
  storyUrl: PropTypes.string.isRequired,
};

export default TrinityPlayer;
